import React, { Suspense } from 'react';
import Loader from '@tekion/tap-components/atoms/Loader';

const withLoadable = (Component) => (props) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} />
  </Suspense>
);

export default withLoadable;
